import React from 'react'
import calcmacroScrImg1 from '../images/sc1.png'
import calcmacroScrImg2 from '../images/sc2.png'
import calcmacroScrImg3 from '../images/sc3.png'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="intro" className={`${this.props.article === 'intro' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Qron Calc Macro</h2>
          <p>For</p>
          <ul>
            <li><a href="https://marketplace.atlassian.com/apps/1217478/qron-calc-macro-excel-formula-in-table?hosting=server&tab=overview">Confluence Server</a></li>
            <li><a href="https://marketplace.atlassian.com/apps/1217478/qron-calc-macro-excel-formula-in-table?hosting=cloud&tab=overview">Confluence Cloud</a></li>
          </ul>
          <p>Transform your standard Confluence table into a spreadsheet.</p>

          <p>
          Have you ever wanted if you could execute a simple calculation on the Confluence table?
          </p>
          <p>
          This addon provides macros which give calculation power as a spreadsheet to Confluence table.
          </p>
          <p>
          Only to add the macro which written sum function to your existing table will release you from typing a calculator.
          </p>
          <p>
          KEY FEATURES
          </p>

          <ul>
            <li>More than 300 formulas</li>
            <li>Format specifications similar to Excel</li>
            <li>Sheet reference between sheets on a page</li>
            <li>Quick edit and displaying sheet/row/column tags on view screen</li>
            <li>Import Excel sheets</li>
          </ul>
          <p><strong>Calculation based on Excel formula</strong>
          <img src={calcmacroScrImg1} alt="" style={{width:"400px"}}/>
            <br/><small>Embedded in standard Confluence table.</small>
          </p>

          <p><strong>Just enter the Excel formula</strong>
          <img src={calcmacroScrImg2} alt="" style={{width:"400px"}}/>
            <br/><small>Give Excel formatting directives your cells. (###.#)</small>
          </p>

          <p><strong>More than 300 formulas in available</strong>
          <img src={calcmacroScrImg3} alt="" style={{width:"400px"}}/>
            <br/><small>SUM(A1:C4), AVERAGE(), COUNTIF(A1:E2, ">5"), so on.</small>
          </p>
          {close}
        </article>

        <article id="work" className={`${this.props.article === 'work' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Qron Find and Replace</h2>
          <p>
            For
          </p>
          <ul>
            <li><a href="https://marketplace.atlassian.com/apps/1215739/qron-search-and-replace-for-confluence?hosting=cloud&tab=overview">Confluence Cloud</a></li>
          </ul>
          <p>Search and replace words in Confluence pages and blogs. It does Native format-aware.</p>
          {close}
        </article>

        <article id="sla" className={`${this.props.article === 'sla' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">SERVICE LEVEL AGREEMENT</h2>
          <h3>Business Hours and Response</h3>
          <ul>
            <li>All days, 4:00AM - 12:00PM PDT</li>
            <li>We will respond within no more than 3 days from the time of your initial request.</li>
          </ul>
          <h3>Support Channel</h3>
          <p>
            You can request support through submitting tickets for our issue tracker.
          </p>
          <h3>Our Support Includes</h3>
          <ul>
            <li>Resolution of problems regarding our products through our issue tracker</li>
          </ul>
          <h3>Our Support does not Include</h3>
          <ul>
            <li>Support in any language other than English</li>
            <li>Phone support</li>
          </ul>
            {close}
        </article>

        <article id="eula" className={`${this.props.article === 'eula' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">EULA</h2>
          <h3>End-User License Agreement (EULA) of <span class="app_name">applications created by Kenputer</span></h3>

          <p>This End-User License Agreement ("EULA") is a legal agreement between you and <span class="company_name">Kenputer</span></p>

          <p>This EULA agreement governs your acquisition and use of our <span class="app_name">applications created by Kenputer</span> software ("Software") directly from <span class="company_name">Kenputer</span> or indirectly through a <span class="company_name">Kenputer</span> authorized reseller or distributor (a "Reseller").</p>

          <p>Please read this EULA agreement carefully before completing the installation process and using the <span class="app_name">applications created by Kenputer</span> software. It provides a license to use the <span class="app_name">applications created by Kenputer</span> software and contains warranty information and liability disclaimers.</p>

          <p>If you register for a free trial of the <span class="app_name">applications created by Kenputer</span> software, this EULA agreement will also govern that trial. By clicking "accept" or installing and/or using the <span class="app_name">applications created by Kenputer</span> software, you are confirming your acceptance of the Software and agreeing to become bound by the terms of this EULA agreement.</p>

          <p>If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not install or use the Software, and you must not accept this EULA agreement.</p>

          <p>This EULA agreement shall apply only to the Software supplied by <span class="company_name">Kenputer</span> herewith regardless of whether other software is referred to or described herein. The terms also apply to any <span class="company_name">Kenputer</span> updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply.</p>

          <h3>License Grant</h3>

          <p><span class="company_name">Kenputer</span> hereby grants you a personal, non-transferable, non-exclusive licence to use the <span class="app_name">applications created by Kenputer</span> software on your devices in accordance with the terms of this EULA agreement.</p>

          <p>You are permitted to load the <span class="app_name">applications created by <span class="company_name">Kenputer</span></span> software (for example a PC, laptop, mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the <span class="app_name">applications created by Kenputer</span> software.</p>

          <p>You are not permitted to:</p>

          <ul>
            <li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things</li>
            <li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose</li>
            <li>Allow any third party to use the Software on behalf of or for the benefit of any third party</li>
            <li>Use the Software in any way which breaches any applicable local, national or international law</li>
            <li>use the Software for any purpose that <span class="company_name">Kenputer</span> considers is a breach of this EULA agreement</li>
          </ul>

          <h3>Intellectual Property and Ownership</h3>

          <p><span class="company_name">Kenputer</span> shall at all times retain ownership of the Software as originally downloaded by you and all subsequent downloads of the Software by you. The Software (and the copyright, and other intellectual property rights of whatever nature in the Software, including any modifications made thereto) are and shall remain the property of <span class="company_name">Kenputer</span>.</p>

          <p><span class="company_name">Kenputer</span> reserves the right to grant licences to use the Software to third parties.</p>

          <h3>Termination</h3>

          <p>This EULA agreement is effective from the date you first use the Software and shall continue until terminated. You may terminate it at any time upon written notice to <span class="company_name">Kenputer</span>.</p>

          <p>It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop all access and use of the Software. The provisions that by their nature continue and survive will survive any termination of this EULA agreement.</p>

          <h3>Governing Law</h3>

          <p>This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of <span class="country">japan</span>.</p>

          <p>Effective starting: Jan 1, 2019</p>
            {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <p>We are developing software for team collaboration field.</p>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js